module.exports = __webpack_public_path__ + "static/media/camera.ba9c7f6d.png";